module.exports = __webpack_public_path__ + "media/images/city/010-tokyo-tower-0bc4dfd388d66761215cf03a8f8c5f5c.svg";